import { render } from "./TemplateItemPlaceholder.vue?vue&type=template&id=4e71559e&scoped=true"
import script from "./TemplateItemPlaceholder.vue?vue&type=script&lang=ts"
export * from "./TemplateItemPlaceholder.vue?vue&type=script&lang=ts"

import "./TemplateItemPlaceholder.vue?vue&type=style&index=0&id=4e71559e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e71559e"

export default script